import h, { FunctionComponent } from 'preact';

const Currency: FunctionComponent<CurrencyProps> = ({ amount }) => {
    // see https://stackoverflow.com/a/2901298, there is a solution if > 3 decimal points
    const amountSeparated = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return <>
        £{amountSeparated}
    </>;
};

interface CurrencyProps {
    amount: string;
}

export default Currency;
